import { iconEthereum } from '#src/atoms/icons/system/iconEthereum.ts';
import type { Props as PaymentMethodIconProps } from '#src/components/paymentMethods/Icon/index.tsx';
import { PaymentMethodIcon } from '#src/components/paymentMethods/Icon/index.tsx';

type Props = Pick<PaymentMethodIconProps, 'size'>;

export const EthWalletIcon = ({ size }: Props) => {
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-blue-400)"
      color="var(--c-white)"
      icon={iconEthereum}
    />
  );
};
